import { MoonIcon, SunIcon } from "@heroicons/react/24/outline";
import { Button } from "react-daisyui";
import { useTernaryDarkMode } from "usehooks-ts";

export default function ThemeSelector() {
  const { isDarkMode, setTernaryDarkMode } = useTernaryDarkMode();
  return (
    <Button
      className="btn-ghost min-h-fit min-w-fit gap-0 rounded-md p-2 transition duration-500 ease-in-out"
      onClick={() => setTernaryDarkMode(isDarkMode ? "light" : "dark")}
    >
      {isDarkMode ? (
        <MoonIcon className="h-6 w-6 fill-current" />
      ) : (
        <SunIcon className="h-6 w-6 fill-current" />
      )}
    </Button>
  );
}
